module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "percent-field",
    class: {
      'single-line': _vm.singleLine
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formattedValue)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cee4a272"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldPercent.vue
// module id = 722
// module chunks = 0